// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2sBPx","label":"LabeledBox_label__3d281"};